import Enums from "@/plugin/Enums";
/**
 * 转换
 */
class Convert {

    /**
     * 到钱币
     * @param value 值
     * @param retain 保留 默认:2
     */
    toMoney (value, retain = 2, minus = Enums.get().Minus.NotAllow){
        let match = value.match(/\./ig)
        if (isNaN(value)){
            throw 'this is not an number.'
        }
        value = Number(value)

        switch (minus) {
            case Enums.get().Minus.Allow:
                break;
            case Enums.get().Minus.NotAllow:
                if (value < 0){
                    throw 'this is not allow minus number.'
                }
                break
            case Enums.get().Minus.NotAllowAndConvert:
                value = Math.abs(value)
                break
        }
        return value.toFixed(retain)
    }

    /**
     * 转换 桩号
     * @param value
     */
    convertStake(value) {
        // if (isNaN(value)){
        //     value = value.replace('K', '').replace('k', '').replace('+', '.')
        //     return Number(value).toFixed(3)
        // }else{
        //     value = Number(value).toFixed(3)
        //     value = value + ''
        //     let values = value.split(".");
        //     let z = Number(values[0])
        //     let x = Number(values[1] || '0') * 100
        //     if (x === 0){
        //         x = '000'
        //     }else if (x < 10){
        //         x = '00'+ x
        //     }else if (x < 100){
        //         x = '0'+ x
        //     }
        //     return `K${z}+${x}`
        // }
        if (value == "0") {
            return "K0+000"
        } else if (value != undefined) {
            let reg = new RegExp("^K.*?");
            value = (value * 1.000).toFixed(3)
            if (reg.test(value)) {
                value = value.slice(1, -4) + value.slice(-3)
            } else {
                let arry = value.split('.')
                value = 'K' + arry[0] + '+' + arry[1]
            }
        }
        return value
    }
}
export default Convert
